import { TermlyPolicyPage } from '../components/legal/TermlyPolicyPage';

const TERMLY_POLICY_ID = '1503ac3b-8332-4ad4-ba64-1d6805a5e4ec';

export function TermsPage() {
  return (
    <TermlyPolicyPage
      policyId={TERMLY_POLICY_ID}
      title="Terms and Conditions"
      description="The rules and conditions for using Filmple."
    />
  );
}
